import { Container, Graphics, Point, Sprite, Text, TextStyle, Texture } from "pixi.js";
export class WalletFullBuilding extends Container {
    private static readonly BUILDING_SIZE = new Point(798, 798);

    private readonly rank: Text;
    private readonly building: Sprite;
    private readonly borderMask: Graphics;

    public constructor() {
        super();
        this.building = new Sprite(Texture.WHITE);
        this.building.width = WalletFullBuilding.BUILDING_SIZE.x;
        this.building.height = WalletFullBuilding.BUILDING_SIZE.y;
        this.building.eventMode = "static";

        this.borderMask = new Graphics();
        this.borderMask.beginFill();
        this.borderMask.drawRoundedRect(0, 0, this.building.width, this.building.height, 20);
        this.borderMask.endFill();
        this.addChild(this.borderMask);
        this.building.mask = this.borderMask;

        this.rank = new Text("Rank 1", new LevelTextStyle());
        this.rank.angle = -8;
        this.rank.skew._x = -0.087;
        this.rank.position.set((this.building.width - this.rank.width) * 0.5, 40);

        this.addChild(this.building, this.rank);
    }

    public updateTexture(buildingTexture: Texture): void {
        this.building.texture = buildingTexture;
    }

    public updateRank(rank: number): void {
        this.rank.text = `Rank ${rank}`;
        this.rank.position.set((this.building.width - this.rank.width) * 0.5, 40);
    }
}

class LevelTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            dropShadow: true,
            dropShadowAlpha: 0.6,
            dropShadowAngle: 0,
            dropShadowBlur: 15,
            dropShadowDistance: 0,
            padding: 20,
            fill: "#ffffff",
            fontFamily: "COMICZ",
            strokeThickness: 1,
            fontSize: 64
        }));
    }
}
